/* global URL_BASE */
const urlBase = {
  h5: URL_BASE.H5,
  ticket: URL_BASE.TICKET,
  pay: URL_BASE.PAY,
  defray: URL_BASE.DEFRAY,
  gaotie: {
    train: URL_BASE.GAOTIE.TRAIN,
    dl: URL_BASE.GAOTIE.DL,
    gt: URL_BASE.GAOTIE.GT
  }
};

export default urlBase;



// WEBPACK FOOTER //
// ./src/request/hosts.js